/**
 *
 * @param projectIdentifier project qualified name
 * @param entityShortId entity short id
 *
 * @example
 * makeEntityIdentifier('workspace/project', 'PROJ-123') // 'workspace/project/PROJ-123'
 */
export function makeEntityIdentifier(projectIdentifier: string, entityShortId: string): string;
/**
 *
 * @param organizationName organization name
 * @param projectName project name
 * @param entityShortId entity short id
 *
 * @example
 * makeEntityIdentifier('workspace', 'project', 'PROJ-123') // 'workspace/project/PROJ-123'
 */
export function makeEntityIdentifier(
  organizationName: string,
  projectName: string,
  entityShortId: string,
): string;

export function makeEntityIdentifier(...parts: string[]): string {
  return parts.join('/');
}

export function makeEntityUUIDidentifier(workspace: string, project: string, uuid: string) {
  return `workspaces/${workspace}/projects/${project}/runs:id/${uuid}`;
}

export function makeEntityCustomIDidentifier(workspace: string, project: string, customId: string) {
  return `workspaces/${workspace}/projects/${project}/runs/${customId}`;
}
